export default "__VITE_ASSET__BW1EX17f__"